import PAYMENT_ORIGIN_ALL from 'constants/payment/paymentOriginAll.const';
import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import withOptions from 'utils/functions/withOptions.util';

const REFUND = Object.freeze([
  PAYMENT_ORIGIN_ALL.amexFee,
  PAYMENT_ORIGIN_ALL.slickPosRefund,
  PAYMENT_ORIGIN_ALL.slickPosDepositRefund,
  PAYMENT_ORIGIN_ALL.cardOnFileRefund,
  PAYMENT_ORIGIN_ALL.noShowFeeRefund,
  PAYMENT_ORIGIN_ALL.ncobDepositRefund,
]);

const NORMAL = Object.freeze([
  PAYMENT_ORIGIN_ALL.slickPos,
  PAYMENT_ORIGIN_ALL.slickPosDeposit,
  PAYMENT_ORIGIN_ALL.slickPosVoucher,
  PAYMENT_ORIGIN_ALL.cardOnFile,
  PAYMENT_ORIGIN_ALL.noShowFee,
  PAYMENT_ORIGIN_ALL.ncobDeposit,
]);

// SEE: https://getslick.atlassian.net/browse/GS-11220
const splitPaymentsByOrigin = withOptions(({ payments }) => {
  const normal = [];
  const refund = [];
  const other = [];

  for (const payment of asArray(payments).filter(alwaysSame)) {
    const { payment_origin: origin } = payment;

    // eslint-disable-next-line no-nested-ternary
    const array = REFUND.includes(origin) ? refund : NORMAL.includes(origin) ? normal : other;

    array.push(payment);
  }

  return { normal, refund, other };
});

export default splitPaymentsByOrigin;
